export default __webpack_public_path__ + "locales/uk-UA/Article.json?hash=d508c76deef3cd3ed3d277739ec96080";